module.exports = __webpack_public_path__ + "static/media/3DPPA3.3762d5b4.jpg";